export function ldJson(url: string): string {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "CinemaGuide",
    url,
    logo: "https://cinemaguideireland.com/favicon.png",
    areaServed: "IE",
  });
}
